/**
 * Centralized route configuration
 * Use this file to define all application routes
 * This ensures type safety and makes route changes easier to manage
 */

export const ROUTES = {
  // Root
  HOME: '/',

  // Authentication
  AUTH: '/auth',

  // Cases
  CASES: '/cases',
  CASE_DETAIL: '/case/:caseId',

  // Stats
  STATS: '/stats/:caseId',

  // Fallback
  NOT_FOUND: '*',
} as const satisfies Record<string, string>;

/**
 * Helper function to generate case detail route with caseKey
 * @param caseKey - The case key to navigate to
 * @returns The formatted route path
 */
export const getCaseRoute = (caseKey: string): string => {
  return `/case/${caseKey}`;
};

/**
 * Type for all available routes
 */
export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];
